module.exports = __webpack_public_path__ + "static/media/format_reload.f0d5d2e2.xlsx";